import { NgModule } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CarouselModule } from 'primeng/carousel';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DataViewModule } from 'primeng/dataview';
import { DatePicker } from 'primeng/datepicker';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DragDropModule } from 'primeng/dragdrop';
import { DialogService } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { FloatLabelModule } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { GalleriaModule } from 'primeng/galleria';
import { InplaceModule } from 'primeng/inplace';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { KnobModule } from 'primeng/knob';
import { ListboxModule } from 'primeng/listbox';
import { MegaMenuModule } from 'primeng/megamenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MessageModule } from 'primeng/message';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrderListModule } from 'primeng/orderlist';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { PaginatorModule } from 'primeng/paginator';
import { PanelModule } from 'primeng/panel';
import { PanelMenuModule } from 'primeng/panelmenu';
import { PasswordModule } from 'primeng/password';
import { PickListModule } from 'primeng/picklist';
import { Popover } from 'primeng/popover';
import { ProgressBarModule } from 'primeng/progressbar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { RatingModule } from 'primeng/rating';
import { RippleModule } from 'primeng/ripple';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { ScrollTopModule } from 'primeng/scrolltop';
import { Select } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SkeletonModule } from 'primeng/skeleton';
import { SliderModule } from 'primeng/slider';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { StepsModule } from 'primeng/steps';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TagModule } from 'primeng/tag';
import { Textarea } from 'primeng/textarea';
import { TerminalModule } from 'primeng/terminal';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { TimelineModule } from 'primeng/timeline';
import { ToastModule } from 'primeng/toast';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { TreeTableModule } from 'primeng/treetable';

const MODULES = [
  AccordionModule,
  AutoCompleteModule,
  AvatarModule,
  AvatarGroupModule,
  BadgeModule,
  BreadcrumbModule,
  ButtonModule,
  CardModule,
  CarouselModule,
  ChartModule,
  CheckboxModule,
  ChipModule,
  ConfirmDialogModule,
  ConfirmPopupModule,
  ColorPickerModule,
  ContextMenuModule,
  DataViewModule,
  DatePicker,
  DialogModule,
  DividerModule,
  DragDropModule,
  EditorModule,
  FieldsetModule,
  FileUploadModule,
  FloatLabelModule,
  IconFieldModule,
  InputIconModule,
  GalleriaModule,
  InplaceModule,
  InputNumberModule,
  InputMaskModule,
  InputTextModule,
  KnobModule,
  ListboxModule,
  MegaMenuModule,
  MenuModule,
  MenubarModule,
  MessageModule,
  MultiSelectModule,
  OrderListModule,
  OrganizationChartModule,
  PaginatorModule,
  PanelModule,
  PanelMenuModule,
  PasswordModule,
  PickListModule,
  Popover,
  ProgressBarModule,
  RadioButtonModule,
  RatingModule,
  RippleModule,
  ScrollPanelModule,
  ScrollTopModule,
  Select,
  SelectButtonModule,
  SkeletonModule,
  SliderModule,
  SplitButtonModule,
  SplitterModule,
  StepsModule,
  TableModule,
  TabsModule,
  TagModule,
  Textarea,
  TerminalModule,
  TimelineModule,
  TieredMenuModule,
  ToastModule,
  ToggleButtonModule,
  ToggleSwitch,
  ToolbarModule,
  TooltipModule,
  TreeModule,
  TreeTableModule,
];

@NgModule({
  imports: MODULES,
  exports: MODULES,
  // ConfirmationService fica no app.module: aqui cada modulo lazy ganharia a propria instancia.
  providers: [DialogService],
})
export class PrimengModule {}

export const primeNgPtBR = {
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'igual a',
  notEquals: 'Diferente de',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior que ou igual a',
  is: 'É',
  isNot: 'Não é',
  before: 'Antes',
  after: 'Depois',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data é antes',
  dateAfter: 'Data é depois',
  clear: 'Limpar',
  apply: 'Aplicar',
  matchAll: 'Combinar tudo',
  matchAny: 'Combinar com qualquer',
  addRule: 'Adicionar Regra',
  removeRule: 'Remover Regra',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Upload',
  cancel: 'Cancelar',
  dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  dayNamesMin: ['Do', 'Se', 'Te', 'Qu', 'Qi', 'Se', 'Sa'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
  ],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  dateFormat: 'mm/dd/yy',
  today: 'Hoje',
  weekHeader: 'Wk',
  weak: 'Semana',
  medium: 'Medium',
  strong: 'Strong',
  passwordPrompt: 'Informe uma senha',
  emptyMessage: 'Nenhum resultado encontrado',
  emptyFilterMessage: 'Nenhum resultado encontrado',

  // Chaves que passaram a existir nas versoes novas do PrimeNG e nao estavam
  // traduzidas - por isso apareciam em ingles (ex.: "{0} items selected" no
  // MultiSelect, que vem de `selectionMessage`). Conferidas contra a interface
  // Translation do pacote instalado.
  completed: 'Concluido',
  pending: 'Pendente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  fileChosenMessage: '{0} arquivos',
  noFileChosenMessage: 'Nenhum arquivo escolhido',
  firstDayOfWeek: 0,
  chooseYear: 'Escolha o ano',
  chooseMonth: 'Escolha o mes',
  chooseDate: 'Escolha a data',
  prevDecade: 'Decada anterior',
  nextDecade: 'Proxima decada',
  prevYear: 'Ano anterior',
  nextYear: 'Proximo ano',
  prevMonth: 'Mes anterior',
  nextMonth: 'Proximo mes',
  prevHour: 'Hora anterior',
  nextHour: 'Proxima hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Proximo minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Proximo segundo',
  am: 'am',
  pm: 'pm',
  searchMessage: '{0} resultados disponiveis',
  selectionMessage: '{0} itens selecionados',
  emptySelectionMessage: 'Nenhum item selecionado',
  emptySearchMessage: 'Nenhum resultado encontrado',

  aria: {
    trueLabel: 'Verdadeiro',
    falseLabel: 'Falso',
    nullLabel: 'Nao selecionado',
    star: '1 estrela',
    stars: '{star} estrelas',
    selectAll: 'Selecionar todos',
    unselectAll: 'Desmarcar todos',
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Proximo',
    navigation: 'Navegacao',
    scrollTop: 'Ir para o topo',
    moveTop: 'Mover para o topo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    moveBottom: 'Mover para o fim',
    moveToTarget: 'Mover para o destino',
    moveToSource: 'Mover para a origem',
    moveAllToTarget: 'Mover todos para o destino',
    moveAllToSource: 'Mover todos para a origem',
    pageLabel: 'Pagina {page}',
    firstPageLabel: 'Primeira pagina',
    lastPageLabel: 'Ultima pagina',
    nextPageLabel: 'Proxima pagina',
    prevPageLabel: 'Pagina anterior',
    rowsPerPageLabel: 'Linhas por pagina',
    previousPageLabel: 'Pagina anterior',
    jumpToPageDropdownLabel: 'Ir para a pagina',
    jumpToPageInputLabel: 'Ir para a pagina',
    selectRow: 'Selecionar linha',
    unselectRow: 'Desmarcar linha',
    expandRow: 'Expandir linha',
    collapseRow: 'Recolher linha',
    showFilterMenu: 'Exibir menu de filtro',
    hideFilterMenu: 'Ocultar menu de filtro',
    filterOperator: 'Operador do filtro',
    filterConstraint: 'Condicao do filtro',
    editRow: 'Editar linha',
    saveEdit: 'Salvar edicao',
    cancelEdit: 'Cancelar edicao',
    listView: 'Visualizacao em lista',
    gridView: 'Visualizacao em grade',
    slide: 'Slide',
    slideNumber: 'Slide {slideNumber}',
    zoomImage: 'Ampliar imagem',
    zoomIn: 'Aproximar',
    zoomOut: 'Afastar',
    rotateRight: 'Girar a direita',
    rotateLeft: 'Girar a esquerda',
    listLabel: 'Lista de opcoes',
    selectColor: 'Selecionar cor',
    removeLabel: 'Remover',
    browseFiles: 'Procurar arquivos',
    maximizeLabel: 'Maximizar',
    minimizeLabel: 'Minimizar',
  },
};
